import { IdType } from "../Utils/IdType";
import { namedQueryKeyWithId, QueryKeyName } from "../ReactQuery/namedQueryKeyWithId";
import { ExtractAllowed } from "../Utils/utilityTypes";

type OpeningTimeQueryName = ExtractAllowed<QueryKeyName, "suppliers" | "odcs" | "plants" | "edcs">;

export const openingTimeWithIdQueryKey = (parentId: IdType, queryName: OpeningTimeQueryName) => [
  ...namedQueryKeyWithId(queryName, parentId),
  "openingTimes",
];
